export enum TextAndImageLayout {
  IMAGE_LEFT = 0,
  IMAGE_RIGHT = 1,
}
